var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "theme-editor" }, [
    _c(
      "div",
      { staticClass: "theme-section" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_setup.t("themePage.synopsisTitle"))),
        ]),
        _c("p", { staticClass: "section-label section-label--with-link" }, [
          _vm._v(_vm._s(_setup.t("themePage.synopsisLabel"))),
        ]),
        _c(
          "router-link",
          {
            staticClass: "synopsis-edit-link",
            attrs: {
              to: { name: "detail", params: { novelId: _setup.props.novelId } },
            },
          },
          [_vm._v(_vm._s(_setup.t("themePage.synopsisEditLink")))]
        ),
        _c(_setup.ThemeTextField, {
          attrs: { name: "synopsis", maxlength: 3000 },
          on: {
            "validation-change": function ($event) {
              return _setup.onFieldValidationChange("synopsis", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "example",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "view-example-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.openExample("synopsisExampleContent")
                        },
                      },
                    },
                    [
                      _c(_setup.IconInfo),
                      _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.theme["synopsis"],
            callback: function ($$v) {
              _vm.$set(_setup.theme, "synopsis", $$v)
            },
            expression: "theme['synopsis']",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "theme-section" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_setup.t("themePage.charactersTitle"))),
        ]),
        _c("p", { staticClass: "section-label" }, [
          _vm._v(_vm._s(_setup.t("themePage.charactersLabel"))),
        ]),
        _c(_setup.ThemeTextField, {
          attrs: { name: "characters", maxlength: 3000 },
          on: {
            "validation-change": function ($event) {
              return _setup.onFieldValidationChange("characters", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "example",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "view-example-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.openExample("charactersExampleContent")
                        },
                      },
                    },
                    [
                      _c(_setup.IconInfo),
                      _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.theme["characters"],
            callback: function ($$v) {
              _vm.$set(_setup.theme, "characters", $$v)
            },
            expression: "theme['characters']",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "theme-section" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_setup.t("themePage.goalTitle"))),
        ]),
        _c("p", { staticClass: "section-label" }, [
          _vm._v(_vm._s(_setup.t("themePage.goalLabel"))),
        ]),
        _c(_setup.ThemeTextField, {
          attrs: { name: "goal", rows: 3, maxlength: 3000 },
          on: {
            "validation-change": function ($event) {
              return _setup.onFieldValidationChange("goal", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "example",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "view-example-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.openExample("goalExampleContent")
                        },
                      },
                    },
                    [
                      _c(_setup.IconInfo),
                      _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.theme["goal"],
            callback: function ($$v) {
              _vm.$set(_setup.theme, "goal", $$v)
            },
            expression: "theme['goal']",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "theme-section" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_setup.t("themePage.themeTitle"))),
        ]),
        _c("p", { staticClass: "section-label" }, [
          _vm._v(_vm._s(_setup.t("themePage.themeLabel"))),
        ]),
        _c(_setup.ThemeTextField, {
          attrs: {
            name: "theme",
            rows: _setup.isMobileScreen ? 2 : 1,
            maxlength: 100,
          },
          on: {
            "validation-change": function ($event) {
              return _setup.onFieldValidationChange("theme", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "example",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "view-example-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.openExample("themeExampleContent")
                        },
                      },
                    },
                    [
                      _c(_setup.IconInfo),
                      _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.theme["theme"],
            callback: function ($$v) {
              _vm.$set(_setup.theme, "theme", $$v)
            },
            expression: "theme['theme']",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "theme-section" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_setup.t("themePage.storyChangesTitle"))),
        ]),
        _c("p", { staticClass: "section-label" }, [
          _vm._v(_vm._s(_setup.t("themePage.storyChangesLabel"))),
        ]),
        _c(_setup.ThemeTextField, {
          attrs: { name: "story-changes", maxlength: 3000 },
          on: {
            "validation-change": function ($event) {
              return _setup.onFieldValidationChange("story-changes", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "example",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "view-example-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.openExample(
                            "storyChangesExampleContent"
                          )
                        },
                      },
                    },
                    [
                      _c(_setup.IconInfo),
                      _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.theme["story-changes"],
            callback: function ($$v) {
              _vm.$set(_setup.theme, "story-changes", $$v)
            },
            expression: "theme['story-changes']",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "theme-section" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_setup.t("themePage.loglineTitle"))),
        ]),
        _c("p", { staticClass: "section-label" }, [
          _vm._v(_vm._s(_setup.t("themePage.loglineLabel"))),
        ]),
        _c(_setup.ThemeTextField, {
          attrs: {
            name: "logline",
            rows: _setup.isMobileScreen ? 2 : 1,
            maxlength: 100,
          },
          on: {
            "validation-change": function ($event) {
              return _setup.onFieldValidationChange("logline", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "example",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "view-example-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.openExample("loglineExampleContent")
                        },
                      },
                    },
                    [
                      _c(_setup.IconInfo),
                      _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.theme["logline"],
            callback: function ($$v) {
              _vm.$set(_setup.theme, "logline", $$v)
            },
            expression: "theme['logline']",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "theme-section" }, [
      _c("h2", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_setup.t("themePage.targetTitle"))),
      ]),
      _c("p", { staticClass: "section-label" }, [
        _vm._v(_vm._s(_setup.t("themePage.targetLabel"))),
      ]),
      _c(
        "div",
        { staticClass: "sub-fields" },
        [
          _c(_setup.ThemeTextField, {
            attrs: {
              name: "target-segment",
              label: _setup.t("themePage.targetSegmentLabel"),
              rows: _setup.isMobileScreen ? 2 : 1,
              maxlength: 100,
            },
            on: {
              "validation-change": function ($event) {
                return _setup.onFieldValidationChange("target-segment", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "example",
                fn: function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "view-example-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.openExample(
                              "targetSegmentExampleContent"
                            )
                          },
                        },
                      },
                      [
                        _c(_setup.IconInfo),
                        _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _setup.theme["target-segment"],
              callback: function ($$v) {
                _vm.$set(_setup.theme, "target-segment", $$v)
              },
              expression: "theme['target-segment']",
            },
          }),
          _c(_setup.ThemeTextField, {
            attrs: {
              name: "target-preference",
              label: _setup.t("themePage.targetPreferenceLabel"),
              rows: _setup.isMobileScreen ? 2 : 1,
              maxlength: 100,
            },
            on: {
              "validation-change": function ($event) {
                return _setup.onFieldValidationChange(
                  "target-preference",
                  $event
                )
              },
            },
            scopedSlots: _vm._u([
              {
                key: "example",
                fn: function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "view-example-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.openExample(
                              "targetPreferenceExampleContent"
                            )
                          },
                        },
                      },
                      [
                        _c(_setup.IconInfo),
                        _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _setup.theme["target-preference"],
              callback: function ($$v) {
                _vm.$set(_setup.theme, "target-preference", $$v)
              },
              expression: "theme['target-preference']",
            },
          }),
          _c(_setup.ThemeTextField, {
            attrs: {
              name: "target-prefer-novels",
              label: _setup.t("themePage.targetNovelsLabel"),
              rows: _setup.isMobileScreen ? 2 : 1,
              maxlength: 100,
            },
            on: {
              "validation-change": function ($event) {
                return _setup.onFieldValidationChange(
                  "target-prefer-novels",
                  $event
                )
              },
            },
            scopedSlots: _vm._u([
              {
                key: "example",
                fn: function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "view-example-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _setup.openExample(
                              "targetNovelsExampleContent"
                            )
                          },
                        },
                      },
                      [
                        _c(_setup.IconInfo),
                        _vm._v(_vm._s(_setup.t("themePage.viewExample")) + " "),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _setup.theme["target-prefer-novels"],
              callback: function ($$v) {
                _vm.$set(_setup.theme, "target-prefer-novels", $$v)
              },
              expression: "theme['target-prefer-novels']",
            },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "theme-section" },
      [
        _c("h2", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_setup.t("themePage.wordLengthTitle"))),
        ]),
        _c("p", { staticClass: "section-label" }, [
          _vm._v(_vm._s(_setup.t("themePage.wordLengthLabel"))),
        ]),
        _c(_setup.ThemeTextField, [
          _c("div", { staticClass: "input-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.theme["word-length"],
                  expression: "theme['word-length']",
                },
              ],
              staticClass: "word-length",
              attrs: {
                type: "text",
                id: "word-length",
                name: "word-length",
                maxlength: "18",
              },
              domProps: { value: _setup.theme["word-length"] },
              on: {
                blur: _setup.formatWordLength,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_setup.theme, "word-length", $event.target.value)
                },
              },
            }),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthSuffix"))),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "annotation" }, [
          _c("p", { staticClass: "annotation-title" }, [
            _vm._v(_vm._s(_setup.t("themePage.wordLengthReference"))),
          ]),
          _c("div", { staticClass: "annotation-grid" }, [
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthFullNovel"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthFullNovelValue"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthMediumNovel"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthMediumNovelValue"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthShortNovel"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthShortNovelValue"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthFlashFiction"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_setup.t("themePage.wordLengthFlashFictionValue"))),
            ]),
          ]),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "save-button-wrapper" }, [
      _c(
        "button",
        {
          staticClass: "save-button",
          attrs: { disabled: !_setup.canSave },
          on: {
            click: function ($event) {
              return _setup.submit("button")
            },
          },
        },
        [_vm._v(" " + _vm._s(_setup.t("themePage.saveButton")) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }